import React from "react";
import * as kycService from "../../services/kyc/kyc-service";
import * as userService from "../../services/user/user-service";
import * as addressService from "../../services/kyc/address-service";
import * as bankService from "../../services/kyc/kyc-service";
import * as contactService from "../../services/kyc/kyc-service";
import { downloadFile } from "../../common/download-file";
import { v4 as uuidv4 } from "uuid";
import Auth from "../../utils/auth";
import validateReg from "../../common/ValidationReg";
import * as validate from "../../utils/validations";
import {
  GSTIN_LinkValid,
  defaultListItem,
  dmy,
  CUSTOMERTYPES,
  FUNCTIONALITY,
  ENTITLEMENTS,
} from "../../common/const";
import { getNoOfdays, dateFormat, StringToDate } from "../../utils/date";
import { Authorize } from "../../components/authorize";
import * as Loader from "../../common/common";
import Utility from "../../components/modal";
import TextBox from "../../components/form-controls/textbox";
import DropDown from "../../components/form-controls/dropdown";
import DropDownGroup from "../../components/form-controls/dropdowngroup";
import * as validateFileExt from "../../common/validate-file-extension";
import { messages } from "../../common/messages";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as xmlService from "../../services/xml/xml-service";
import { commonDownloadPdf } from "../../common/download-pdf";
import * as commonDownloadPdfService from "../../services/pdf/download_pdf_service";
import { validateEntitlement } from "../../common/validate-entitlement";
import XmlDownload from "../../components/xml-download/xml-download";
import config from "../../common/config";
import { withOutletPropsAndNavigation } from "../../common/hocs";

let formData;
let userType;
let disableApproveButton = false;
let disableRejectButton = false;
let disableConfirmButton;
let kycStatus;

class Customer extends Authorize {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setInitialData = this.setInitialData.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.onKeyPressDate = this.onKeyPressDate.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
  }
  role = Auth.get("role");

  state = {
    dirty: false,
    clientId: this.props.clientId,
    displayLabel: this.props.clientType,
    userType: this.props.clientType,
    loginUserType: Auth.get("userType"),
    showStatus: false,
    status: "",
    fileUploadError: "",
    kycForm: {
      customer: "",
      custCode: "",
      addressLineOne: "",
      addressLineTwo: "",
      addressLineThree: "",
      addressLineFour: "",
      city: "",
      state: "",
      postalCode: "",
      gstinNo: "",
      gstinStatus: "",
      operationsEmails: "",
      finMailIds: "",
      contactPerson: "",
      contactNo: "",
      pan: "",
      incorporation: "",
      dateOfIncorporation: "",
      tdsDetailsOne: "",
      tdsPercentageOne: "",
      tdsDetailsTwo: "",
      tdsPercentageTwo: "",
      sezFrmDate: "",
      sezToDate: "",
      gstTaxPayerDetails: "",
      tan: "",
      rejectionReason: "",
      department: "",
      typeOfIndustry: "",
      legalStatus: "",
      supplPremises: "",
      yrsInBusiness: "",
      annualSales: "",
      noOfEmployees: "",
      companyType: "",
      compTypeNAReason: "",
      taxExemption: "",
      rocRegnNo: "",
      taxLowerRate: "",
      tradeLicenseNo: "",
      gstCompScheme: "",
      fileUploadType: "",
      msmeRegNo: "",
    },
    customerTypes: [],
    contactList: [],
    message: "",
    validationErrors: {
      custNameError: "",
      customerError: "",
      addressError: "",
      cityError: "",
      stateError: "",
      postalCodeError: "",
      gstinStatusError: "",
      operationsEmailsError: "",
      finMailIdsError: "",
      contactPersonError: "",
      contactNoError: "",
      panError: "",
      tanError: "",
      incorporationError: "",
      tdsDetailsOneError: "",
      tdsPercentageOneError: "",
      gstTaxPayerDetailsError: "",
      gstnStatusError: "",
      customerTypesError: "",
      departmentError: "",
      typeOfIndustryError: "",
      legalStatusError: "",
      supplPremisesError: "",
      yrsInBusinessError: "",
      annualSalesError: "",
      noOfEmployeesError: "",
      companyTypeError: "",
      compTypeNAReasonError: "",
      taxExemptionError: "",
      rocRegnNoError: "",
      taxLowerRateError: "",
      tradeLicenseNoError: "",
      gstCompSchemeError: "",
      websiteError: "",
      gstinNoError: "",
      sezFromDateError: "",
      sezToDateError: "",
      fileUploadTypeError: "",
      msmeRegNoError: "",
    },
    gstStatusData: {},
    stateData: {},
    tdsDetails: {},
    taxPayerTypesData: {},
    deptData: {},
    legalStatusData: {},
    supplPremisesData: {},
    companyTypeData: {},
    taxExemptionData: {},
    taxLowerRateData: {},
    gstCompSchemeData: {},
    fileUploadTypesData: {},
    isSupplier: false,
    deletedFiles: [],
    files: [],
    displayRejReason: false,
    enableCode: false,
    showGSTINNo: false,
    disableKyc: false,
    mandatoryFiles: [],
    regenerateMsg: "",
    isDatePickerDisable: false,
  };
  setInitialData(context) {
    let gstStatusData = [];
    let stateData = [];
    let tdsDetails = [];
    let taxPayerTypesData = [];
    let deptData = [];
    let legalStatusData = [];
    let supplPremisesData = [];
    let companyTypeData = [];
    let taxExemptionData = [];
    let taxLowerRateData = [];
    let gstCompSchemeData = [];
    let fileUploadTypesData = [];
    let fileUploadType =
      this.props.clientType === "Customer" ? "CustomerDOC" : "SupplierDOC";
    Loader.showLoader();
    if (!!context) {
      let actions = context.actions;
      gstStatusData = actions.getMastersByGroup("GstStatus");
      stateData = actions.getMastersByGroup("State");
      tdsDetails = actions.getMastersByGroup("TDSDetails");
      taxPayerTypesData = actions.getMastersByGroup("TaxPayerType");
      deptData = context.state.departments;
      legalStatusData = actions.getMastersByGroup("legalstatus");
      supplPremisesData = actions.getMastersByGroup("supplierpremises");
      companyTypeData = actions.getMastersByGroup("companytype");
      taxExemptionData = actions.getMastersByGroup("taxexemption");
      taxLowerRateData = actions.getMastersByGroup("taxlowerrate");
      gstCompSchemeData = actions.getMastersByGroup("gstcompositionscheme");
      fileUploadTypesData = actions.getMastersByGroup(fileUploadType);
    }
    this.setState({
      ...this.state,
      gstStatusData: gstStatusData,
      stateData: stateData,
      tdsDetails: tdsDetails,
      taxPayerTypesData: taxPayerTypesData,
      deptData: deptData,
      legalStatusData: legalStatusData,
      supplPremisesData: supplPremisesData,
      companyTypeData: companyTypeData,
      taxExemptionData: taxExemptionData,
      taxLowerRateData: taxLowerRateData,
      gstCompSchemeData: gstCompSchemeData,
      fileUploadTypesData: fileUploadTypesData,
    });

    Loader.hideLoader();
  }

  async downloadPdf(clientId, userType) {
    let data = {
      clientId: clientId,
      userType: userType,
    };
    let { response, err } = await commonDownloadPdfService.downloadClient(data);
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(
        response.data,
        this.state.kycForm.finLedgerCode
          ? this.state.kycForm.finLedgerCode
          : "clientPDF",
        "noDateTimeStampRequired"
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.context !== prevProps.context) {
      this.setInitialData(this.props.context);
    }
  }

  async componentDidMount() {
    this.setInitialData(this.props && this.props.context);
    let userInfo = await userService.getUser({ id: this.state.clientId });
    let custCode = await userService.genrateCustCode({
      clientId: this.state.clientId,
    });

    if (userInfo && userInfo.response && userInfo.response.data) {
      this.setState({
        kycForm: {
          ...this.state.kycForm,
          customer: userInfo.response.data.name,
          pan: userInfo.response.data.pan,
          gstinNo: userInfo.response.data.gstin,
          gstinStatus: userInfo.response.data.gstin ? "0" : "1",
          contactNo: userInfo.response.data.mobile,
          custCode: custCode.response.data.custCode,
        },
        custCodeExceptCHA: custCode.response.data.custCode,
        // showGSTINNo: userInfo.response.data.gstin ? true : false,
        disableGSTIN: userInfo.response.data.gstin ? true : false,
      });
    }
    let clientInfo = await kycService.getClientInfo(this.state.clientId);
    if (
      clientInfo &&
      clientInfo.response &&
      clientInfo.response.data &&
      clientInfo.response.data.Client
    ) {
      this.fillClientDetails(clientInfo.response.data);
      

    }
    if (userInfo.response.data.gstin || clientInfo?.response?.data?.ClientAddress?.gstinStatus === "0"){
      this.setState({ showGSTINNo: true });
    }      

    this.setState({
      isSupplier: this.props.clientType !== "Customer" ? true : false,
    });
    if (
      this.state.loginUserType !== "InternalUser" &&
      this.state.kycForm.kycStatus
    ) {
      if (
        this.state.kycForm.kycStatus !== "REOPENED" &&
        this.state.kycForm.kycStatus !== "DRAFT" &&
        this.state.kycForm.kycStatus !== "REJECTED"
      ) {
        this.disableForm();
        this.setState({
          disableKyc: true,
        });
      }
    }

    this.getAllContactList();
  }

  async getAllContactList() {
    let clientId = this.state.clientId;
    Loader.showLoader();
    let { response, err } = await contactService.getContactList(clientId);
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      this.setState({
        contactList:
          response.data && response.data.length > 0 ? response.data : [],
      });
    }
  }
  fillClientDetails = (clientInfo) => {
    let kycForm = {};
    if (clientInfo && clientInfo.Client) {
      kycForm.customer = clientInfo.Client.customer;
      kycForm.website = clientInfo.Client.website;
      kycForm.operationsEmails = clientInfo.Client.operationsEmails;
      kycForm.finMailIds = clientInfo.Client.financeEmails;
      kycForm.pan = clientInfo.Client.pan;
      if (this.props.clientType === "Supplier") {
        kycForm.dateOfIncorporation1 = clientInfo.Client.dateOfIncorporation ? new Date(
          StringToDate(clientInfo.Client.dateOfIncorporation)
        ) : "";
        kycForm.dateOfIncorporation = kycForm.dateOfIncorporation ? dateFormat(
          clientInfo.Client.dateOfIncorporation,
          dmy
        ) : "";
        kycForm.yrsInBusiness = clientInfo.Client.noOfYears;
        kycForm.rocRegnNo = clientInfo.Client.rocRegnNo;
        kycForm.tradeLicenseNo = clientInfo.Client.tradeLicense;
      }
      kycForm.tan = clientInfo.Client.tan;
      kycForm.typeOfIndustry = clientInfo.Client.industryType;
      kycForm.legalStatus = clientInfo.Client.statusDate;
      kycForm.supplPremises = clientInfo.Client.suppPremises;
      kycForm.annualSales = clientInfo.Client.annualSales;
      kycForm.noOfEmployees = clientInfo.Client.noOfEmployees;
      kycForm.compTypeNAReason = clientInfo.Client.naReason;
      kycForm.taxExemption = clientInfo.Client.taxExemption;
      kycForm.taxLowerRate = clientInfo.Client.taxLowerRate;
      kycForm.gstCompScheme = clientInfo.Client.gstCompScheme;
      kycForm.companyType = clientInfo.Client.companyType;
      kycForm.contactPerson = clientInfo.Client.contactPerson;
      kycForm.contactNo = clientInfo.Client.contactNumber;
      kycForm.kycStatus = clientInfo.Client.kycStatus;
      kycForm.rejectionReason = clientInfo.Client.rejectionReason;
      kycForm.custCode =
        this.state.kycForm.custCode || clientInfo.Client.custCode;
      kycForm.legalStatus = clientInfo.Client.legalStatus;
      kycForm.department = clientInfo.Client.department;
      kycForm.finLedgerCode = clientInfo.Client.finLedgerCode || "";
      kycForm.msmeRegNo = clientInfo.Client.msmeRegNo;
    }
    if (clientInfo && clientInfo.ClientAddress) {
      kycForm.AddressId = clientInfo.ClientAddress.addressId;
      kycForm.businessEntity = clientInfo.ClientAddress.businessEntity;
      kycForm.addressLineOne = clientInfo.ClientAddress.addressLine1;
      kycForm.addressLineTwo = clientInfo.ClientAddress.addressLine2;
      kycForm.addressLineThree = clientInfo.ClientAddress.addressLine3;
      kycForm.addressLineFour = clientInfo.ClientAddress.addressLine4;
      kycForm.city = clientInfo.ClientAddress.city;
      kycForm.state = clientInfo.ClientAddress.state;
      kycForm.postalCode = clientInfo.ClientAddress.postalCode;
      kycForm.gstinNo =
        clientInfo.ClientAddress.gstin !== null
          ? clientInfo.ClientAddress.gstin
          : this.state.kycForm.gstinNo
            ? this.state.kycForm.gstinNo
            : "";
      kycForm.gstinStatus = clientInfo.ClientAddress.gstinStatus;
      kycForm.gstTaxPayerDetails = clientInfo.ClientAddress.gstTaxpayerType;
      kycForm.sezFrmDate1 = clientInfo.ClientAddress.fromDate
        ? new Date(StringToDate(clientInfo.ClientAddress.fromDate))
        : "";
      kycForm.sezFrmDate = clientInfo.ClientAddress.fromDate
        ? dateFormat(clientInfo.ClientAddress.fromDate, dmy)
        : "";
      kycForm.sezToDate1 = clientInfo.ClientAddress.toDate
        ? new Date(StringToDate(clientInfo.ClientAddress.toDate))
        : "";
      kycForm.sezToDate = clientInfo.ClientAddress.toDate
        ? dateFormat(clientInfo.ClientAddress.toDate, dmy)
        : "";
      kycForm.emailIds = clientInfo.ClientAddress.emailIds;
      kycForm.addressCode = clientInfo.ClientAddress.addressCode || "";

      if (clientInfo.ClientAddress.gstinStatus === "0"){
        this.setState({ showGSTINNo: true });
      }

      if (clientInfo.ClientAddress.gstTaxpayerType === "01") {
        this.setState({ showSEZFrmToDate: true });
      }
    }
    if (clientInfo && clientInfo.CustomerTDS) {
      kycForm.tdsDetailsOne =
        clientInfo.CustomerTDS[1] && clientInfo.CustomerTDS[1].tdsValue;
      kycForm.tdsPercentageOne =
        clientInfo.CustomerTDS[1] && clientInfo.CustomerTDS[1].tdsPercentage;
      kycForm.tdsDetailsTwo =
        clientInfo.CustomerTDS[0] && clientInfo.CustomerTDS[0].tdsValue;
      kycForm.tdsPercentageTwo =
        clientInfo.CustomerTDS[0] && clientInfo.CustomerTDS[0].tdsPercentage;
    }
    if (clientInfo && clientInfo.CustomerType) {
      var customerTypes = [];
      let tmpCustArr = clientInfo.CustomerType;
      for (var i = 0; i < tmpCustArr.length; i++) {
        customerTypes.push(tmpCustArr[i].custType);
      }
    }
    if (clientInfo && clientInfo.FileUpload) {
      var files = [];
      let tmpFiles = clientInfo.FileUpload;
      for (var j = 0; j < tmpFiles.length; j++) {
        files.push({
          fileId: tmpFiles[j].fileId,
          name: tmpFiles[j].fileName,
          fileType: tmpFiles[j].fileType,
        });
      }
    }
    this.setState({
      ...this.state,
      kycForm,
      customerTypes,
      files,
      enableCode: customerTypes.indexOf("CHA") > 0 ? true : false,
    });
  };

  disableForm() {
    var form = document.getElementById("formClient");
    var elements = form.elements;
    for (var i = 0, len = elements.length; i < len; ++i) {
      elements[i].setAttribute("disabled", "");
      this.state.isDatePickerDisable = true;
    }
  }
  validateContact_details() {
    let tax_responsible_person_list = [];
    let acPayable_responsible_person_list = [];
    let acReceivable_responsible_person_list = [];
    let msg = "";
    tax_responsible_person_list = this.state.contactList.filter((con) => {
      if (con.contactType === "TAX responsible person") return con;
    });
    if (tax_responsible_person_list.length === 0) {
      msg = "TAX responsible person contact";
    } else if (this.state.isSupplier) {
      acReceivable_responsible_person_list = this.state.contactList.filter(
        (con) => {
          if (con.contactType === "A/c receivable responsible person")
            return con;
        }
      );
      if (acReceivable_responsible_person_list.length === 0) {
        msg = "A/c receivable responsible person contact";
      }
    } else {
      acPayable_responsible_person_list = this.state.contactList.filter(
        (con) => {
          if (con.contactType === "A/c Payable responsible person") return con;
        }
      );
      if (acPayable_responsible_person_list.length === 0) {
        msg = "A/c Payable responsible person contact";
      }
    }
    return msg;
  }
  async handleSubmit(s, e) {
    Loader.showLoader();
    if (!e) {
      e = s;
    }
    e.preventDefault();

    let kycForm = this.state.kycForm;
    let errors = await this.validateForm();
    let isError = false;
    let userId = Auth.get("userId");

    if (Object.keys(errors).length > 0) {
      isError = true;
    }
    if (isError) {
      this.setState({
        validationErrors: errors,
      });
      Loader.hideLoader();
    } else {
      let objClient = {
        clientId: this.state.clientId,
        finLedgerCode: kycForm.finLedgerCode,
        customer: kycForm.customer,
        website: kycForm.website,
        operationsEmails: kycForm.operationsEmails,
        financeEmails: kycForm.finMailIds,
        pan: kycForm.pan,
        dateOfIncorporation: kycForm?.dateOfIncorporation,
        noOfYears: kycForm?.yrsInBusiness,
        rocRegnNo: kycForm?.rocRegnNo,
        tradeLicense: kycForm?.tradeLicenseNo,
        tan: kycForm.tan,
        rejectionReason: kycForm.rejectionReason,
        industryType: kycForm.typeOfIndustry,
        legalStatus: kycForm.legalStatus,
        suppPremises: kycForm.supplPremises,
        annualSales: kycForm.annualSales,
        noOfEmployees: kycForm.noOfEmployees,
        naReason: kycForm.compTypeNAReason,
        taxExemption: kycForm.taxExemption,
        taxLowerRate: kycForm.taxLowerRate,
        gstCompScheme: kycForm.gstCompScheme,
        companyType: kycForm.companyType,
        contactPerson: kycForm.contactPerson,
        contactNumber: kycForm.contactNo,
        custCode: kycForm.custCode,
        department: kycForm.department,
        updatedBy: userId,
        flag: s,
        msmeRegNo: kycForm.msmeRegNo,
      };
      if (!kycForm.finLedgerCode) {
        objClient.createdBy = userId;
        objClient.isActive = 1;
        objClient.isDeleted = 0;
      }
      if (s) {
        if (s === "Approval") {
          objClient.kycStatus = "SUBMITTED";
          objClient.statusDate = new Date();
        } else if (kycForm.kycStatus && kycForm.kycStatus !== "DRAFT") {
          objClient.kycStatus = kycForm.kycStatus;
        } else {
          objClient.kycStatus = "DRAFT";
        }
      }
      let addressObj = {
        addressId: kycForm.AddressId || uuidv4(),
        addressCode: kycForm.addressCode,
        businessEntity: "",
        addressType: "DEFAULT",
        addressLine1: kycForm.addressLineOne,
        addressLine2: kycForm.addressLineTwo,
        addressLine3: kycForm.addressLineThree,
        addressLine4: kycForm.addressLineFour,
        city: kycForm.city,
        state: kycForm.state,
        postalCode: kycForm.postalCode,
        gstin: kycForm.gstinNo,
        gstinStatus: kycForm.gstinStatus,
        gstTaxpayerType: kycForm.gstTaxPayerDetails,
        fromDate: kycForm.sezFrmDate,
        toDate: kycForm.sezToDate,
        emailIds: "",
        updatedBy: userId,
        clientId: this.state.clientId,
      };
      if (!kycForm.AddressId) {
        addressObj.createdBy = userId;
        addressObj.isActive = 1;
        addressObj.isDeleted = 0;
      }
      let deptId = this.state.deptData.filter((dep) => {
        if (dep.deptName === kycForm.department) return dep;
      })[0].deptId;
      let userDeptObj = {
        id: uuidv4(),
        userId: this.state.clientId,
        deptId: deptId,
        createdBy: userId,
        updatedBy: userId,
      };
      let tdsDetailsObj = [];
      let objtds = {};
      if (kycForm.tdsDetailsOne) {
        objtds = {
          tdsId: uuidv4(),
          clientId: this.state.clientId,
          tdsValue: kycForm.tdsDetailsOne,
          tdsPercentage: kycForm.tdsPercentageOne,
          isActive: 1,
          isDeleted: 0,
          createdBy: userId,
          updatedBy: userId,
        };
        tdsDetailsObj.push(objtds);
      }
      if (kycForm.tdsDetailsTwo) {
        objtds = {
          tdsId: uuidv4(),
          clientId: this.state.clientId,
          tdsValue: kycForm.tdsDetailsTwo,
          tdsPercentage: kycForm.tdsPercentageTwo,
          isActive: 1,
          isDeleted: 0,
          createdBy: userId,
          updatedBy: userId,
        };
        tdsDetailsObj.push(objtds);
      }

      let tmpfiles = this.state.files;
      let objFileUpload = [];
      for (var i = 0; i < tmpfiles.length; i++) {
        objFileUpload.push({
          fileId: tmpfiles[i].fileId,
          fileName: tmpfiles[i].name,
          fileType: tmpfiles[i].fileType,
          clientId: this.state.clientId,
          isActive: 1,
          isDeleted: 0,
          createdBy: userId,
          updatedBy: userId,
        });
      }

      let obj = { tdsDetailsObj };
      let custTypes = this.state.customerTypes;
      let objCustType = [];
      for (var k = 0; k < custTypes.length; k++) {
        objCustType.push({
          custTypeId: uuidv4(),
          clientId: this.state.clientId,
          custType: custTypes[k],
          isActive: 1,
          isDeleted: 0,
          createdBy: userId,
          updatedBy: userId,
        });
      }
      let isSaved = true;
      let res = "";

      if (s === "Approval") {
        if (!kycForm.kycStatus) {
          Loader.hideLoader();
          isSaved = false;
          Utility.showAlert(
            "Please save " +
            (this.state.isSupplier ? "Supplier" : "Customer") +
            " details before submitting KYC for approval."
          );
          return;
        }

        // Validation of bank and contact details for Supplier
        if (this.state.userType === "Supplier") {
          res = await bankService.getAllActiveBanksDetails(this.state.clientId);
          if (res.response && res.response.data.length === 0) {
            Loader.hideLoader();
            Utility.showAlert(
              "Please save " +
              (this.state.isSupplier ? "Supplier" : "Customer") +
              " details and then provide atleast one bank detail before submiting KYC for approval."
            );
            isSaved = false;
            return false;
          }
        }

        let isSupCust =
          "/" + (this.state.isSupplier ? "Supplier" : "Customer") + "/";
        let gotoTabName = "/kyc/" + "addresses";

        if(this.state.isSupplier){
          let msg = this.validateContact_details();
          if (msg) {
            Utility.showAlert(
              "You need to fill at least one " + msg + " detail before submit."
            );
            Loader.hideLoader();
            this.props.navigate(gotoTabName);
            return false;
          }
        }
      }

      let commonObj = {
        objClient: objClient,
        userDeptObj: userDeptObj,
        addressObj: addressObj,
        objCustType: objCustType,
        objFileUpload: objFileUpload,
        objTds: obj,
      };
      res = await kycService.saveClient(commonObj);
      if (!res.err) {
        let newAddressId =
          res &&
          res.response &&
          res.response.data &&
          res.response.data.saveAdress &&
          res.response.data.saveAdress.addressId;
        let kycForm = Object.assign({}, this.state.kycForm);
        kycForm.AddressId = newAddressId;
        this.setState({
          kycForm,
        });
      } else {
        isSaved = false;
      }
      Loader.hideLoader();
      if (isSaved) {
        this.setState({
          validationErrors: {},
        });
        document.documentElement.scrollTop = 0;
        this.setState({
          succesMsg:
            s === "Approval"
              ? "KYC submitted for approval"
              : "Saved successfully",
          showSuccess: true,
        });
        if (s && s === "next") {
          const nextPath =
            this.state.userType === "Customer" ? "addresses" : "contacts";

          if (this.state.userType !== this.state.loginUserType) {
            this.props.navigate(
              "/kycs/" +
              this.state.clientId +
              "/" +
              this.state.userType +
              // "/addresses"
              `/${nextPath}`
            );
          } else {
            // this.props.navigate("/kyc/addresses");
            this.props.navigate(`/kyc/${nextPath}`);

          }
        }
        if (s === "Approval") {
          this.disableForm();
          this.setState({
            disableKyc: true,
          });
        }
      }
    }
    Loader.hideLoader();
  }

  handleStatus = async (e) => {
    Loader.showLoader();
    let button = e.target.value;
    let res = "";
    let errors = {};
    if (button !== "Reject") {
      errors = this.validateForm();
    }
    let isError = false;
    let keys = Object.keys(errors);
    for (let i = 0; i < keys.length; i++) {
      if (keys.hasOwnProperty(keys[i])) {
        isError = true;
      }
    }
    if (isError) {
      this.setState({
        validationErrors: errors,
      });
      Loader.hideLoader();
    } else {
      if (button === "Reject") {
        this.setState({
          displayRejReason: true,
        });
      }
      if (button === "Approve" || button === "Confirm") {
        res = await kycService.checkBeforeApprove(
          this.state.clientId,
          this.state.isSupplier
        );

        if (
          res &&
          res.response &&
          res.response.data &&
          !res.response.data.success
        ) {
          let isSupCust =
            "/" + (this.state.isSupplier ? "Supplier" : "Customer") + "/";
          let gotoTabName =
            "/kycs/" +
            this.state.clientId +
            isSupCust +
            (res.response && res.response.data && res.response.data.tab);
          let msg = res.response && res.response.data && res.response.data.msg;
          Utility.showAlert(
            "You need to fill at least one " + msg + " detail before approving."
          );
          Loader.hideLoader();
          this.props.navigate(gotoTabName);
          return false;
        }
        let isSupCust =
          "/" + (this.state.isSupplier ? "Supplier" : "Customer") + "/";
        let gotoTabName =
          "/kycs/" + this.state.clientId + isSupCust + "addresses";
        if(this.state.isSupplier){
          let msg = this.validateContact_details();

          if (msg) {
            Utility.showAlert(
              "You need to fill at least one " +
              msg +
              " detail before " +
              button +
              "."
            );
            Loader.hideLoader();
            this.props.navigate(gotoTabName);
            return false;
          }
        }
      }
      if (
        (button === "Reject" && this.state.kycForm.rejectionReason) ||
        button === "Approve" ||
        button === "Confirm"
      ) {
        let data = {
          clientId: this.state.clientId,
          kycStatus:
            button === "Approve"
              ? "APPROVED"
              : button === "Reject"
                ? "REJECTED"
                : "CONFIRMED",
          rejectionReason:
            button === "Reject" ? this.state.kycForm.rejectionReason : "",
          statusDate: new Date(),
        };
        res = await kycService.saveKycStatus(data);
        if (!res.err) {
          if (button === "Approve" || button === "Confirm") {
            this.setState({
              disableApproveButton: true,
            });
          }
          this.setState({
            displayRejReason: button === "Reject" ? true : false,
            showStatus: true,
            status: data.kycStatus,
          });
        } else {
        }
      }
      Loader.hideLoader();
    }
  };

  // onKeyPressDate = (e) => {
  //   let value = e.target.value;
  //   let name = e.target.name;
  //   let errorName = name + "Error";
  //   if (value.length > 10) {
  //     e.preventDefault();
  //     return false;
  //   }
  //   this.setState({
  //     kycForm: {
  //       ...this.state.kycForm,
  //       [name]: value,
  //     },
  //     validationErrors: {
  //       ...this.state.validationErrors,
  //       [errorName]: "",
  //     },
  //   });
  // };

  onKeyPressDateValidation = (e) => {
    e.preventDefault();
    return false;
    // if (validate.isValidKeyPressDate(e.which)) {
    //   e.preventDefault();
    //   return false;
    // }
  };
  onKeyPressPercentage = (e) => {
    if (validate.isDecimalKey(e.target.value, e.which)) {
      e.preventDefault();
    }
  };
  onKeyPressNumber = (e) => {
    if (e.target.name === "custCode") {
      let isCHA = this.state.customerTypes.indexOf("CHA") >= 0 ? true : false;
      if (isCHA) {
        // if (validate.isValidKeyPressNumber(e.which)) {
        //   e.preventDefault();
        // }
      }
    } else {
      if (validate.isValidKeyPressNumber(e.which)) {
        e.preventDefault();
      }
    }
  };

  handleChange(name, date) {
    if (date !== undefined && date !== null && date !== "") {
      let formatedDate = dateFormat(date);
      this.setState({
        kycForm: {
          ...this.state.kycForm,
          [name + 1]: date,
          [name]: formatedDate,
        },
      });
    }
  }

  onChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    if (name === "tdsPercentageOne" || name === "tdsPercentageTwo") {
      if (validate.isPercentage(value)) {
        this.setState({
          kycForm: {
            ...this.state.kycForm,
            [name]: value,
          },
          dirty: true,
        });
      }
    } else if (
      name === "pan" ||
      name === "gstinNo" ||
      name === "tan" ||
      name === "contactPerson" ||
      name === "addressLineOne" ||
      name === "addressLineTwo" ||
      name === "addressLineThree" ||
      name === "addressLineFour" ||
      name === "city" ||
      name === "rocRegnNo" ||
      name === "tradeLicenseNo" ||
      name === "typeOfIndustry"
    ) {
      if (value.match(config.regex) || value === "") {
        this.setState({
          kycForm: {
            ...this.state.kycForm,
            [name]: value.toUpperCase(),
          },
          dirty: true,
        });
      }
    } else {
      this.setState({
        kycForm: {
          ...this.state.kycForm,
          [name]: value,
        },
        dirty: true,
      });
    }

    if (name === "companyType" && value === "4") {
      this.setState({
        showNAReasonComp: true,
        kycForm: {
          ...this.state.kycForm,
          msmeRegNo: "",
          companyType: value,
        },
      });
    } else if (name === "companyType" && value !== "4") {
      this.setState({ showNAReasonComp: false });
    } else if (name === "gstTaxPayerDetails" && value === "01") {
      this.setState({ showSEZFrmToDate: true });
    } else if (name === "gstTaxPayerDetails" && value !== "01") {
      this.setState({ showSEZFrmToDate: false });
    } else if (name === "gstTaxPayerDetails" && value === "04") {
      this.setState({ disableTaxFilepload: true });
    } else if (name === "gstTaxPayerDetails" && value !== "04") {
      this.setState({ disableTaxFilepload: false });
    } else if (name === "gstinStatus" && value === "0") {
      this.setState({ showGSTINNo: true });
    } else if (name === "gstinStatus" && value === "1") {
      this.setState({ showGSTINNo: false });
    }
  };

  validateForm = async () => {
    let validationErrors = {};
    let kycForm = Object.assign({}, this.state.kycForm);
    let userType = this.props.clientType;
    if (!this.state.isSupplier) {
      let custData = {};
      custData.custCode = this.state.kycForm.custCode;
      custData.clientId = this.state.clientId;
      let custCode = await userService.isExistCustCode({ custData: custData });
      if (
        custCode.response &&
        custCode.response.data &&
        custCode.response.data.code !== 0
      ) {
        validationErrors.custNameError =
          (userType === "Customer" ? "Customer" : "Supplier") +
          " Code already exists.";
      }

      if (!kycForm.custCode) {
        validationErrors.custNameError =
          "Enter " +
          (userType === "Customer" ? "Customer" : "Supplier") +
          " Code";
      }
    }

    if (!kycForm.customer) {
      validationErrors.customerError =
        "Enter " + (userType === "Customer" ? "Customer" : "Supplier") + "Name";
    }
    if (!kycForm.addressLineOne) {
      validationErrors.addressLineOneError = "Enter Address";
    }
    if (!kycForm.addressLineTwo) {
      validationErrors.addressLineTwoError = "Enter Address";
    }
    if (!kycForm.city) {
      validationErrors.cityError = "Enter City/Town";
    }
    if (!kycForm.state) {
      validationErrors.stateError = "Select State";
    }
    if (!kycForm.postalCode) {
      validationErrors.postalCodeError = "Enter Postal Code";
    }
    if (
      !validateReg.numberValid.test(kycForm.postalCode) &&
      kycForm.postalCode.length > 6
    ) {
      validationErrors.postalCodeError = "Enter Valid Postal Code";
    }
    if (!kycForm.gstinStatus) {
      validationErrors.gstinStatusError = "Enter GSTIN Status";
    }
    if (!kycForm.gstinNo && kycForm.gstinStatus === "0") {
      validationErrors.gstinNoError = "Enter GSTIN Number";
    }
    if (kycForm.gstinStatus === "0") {
      if (!validate.isValidGST(kycForm.gstinNo)) {
        validationErrors.gstinNoError = "Enter Valid GSTIN Number";
      } else if (kycForm.gstinNo.slice(2, 12) !== kycForm.pan) {
        validationErrors.gstinNoError = "Not valid GSTIN for the given Pan";
      }
    }
    if (!kycForm.operationsEmails) {
      validationErrors.operationsEmailsError = "Enter Operations Email";
    }
    if (!kycForm.finMailIds) {
      validationErrors.finMailIdsError = "Enter Finance Email";
    }
    if (!kycForm.contactPerson) {
      validationErrors.contactPersonError = "Enter Contact Person";
    }
      
    if (!kycForm.pan) {
      validationErrors.panError = "Enter PAN";
    }
    if (!validate.isValidPAN(kycForm.pan)) {
      validationErrors.panError = "Enter Valid PAN";
    }

    if (!kycForm.customer) {
      if (!kycForm.dateOfIncorporation) {
        validationErrors.incorporationError = "Enter Date Of Incorporation";
      } else if (!validate.isValidDateFormat(kycForm.dateOfIncorporation)) {
        validationErrors.incorporationError =
          "Enter Date Of Incorporation in dd-mm-yyyy format";
      } else if (getNoOfdays(StringToDate(kycForm.dateOfIncorporation)) <= 0) {
        validationErrors.incorporationError = "Enter Valid Date Of Incorporation";
      }

      if (!kycForm.yrsInBusiness) {
        validationErrors.yrsInBusinessError = "Enter Number Of Years In Business";
      }
    }
    if (kycForm.tdsDetailsOne && !kycForm.tdsPercentageOne) {
      validationErrors.tdsPercentageOneError = "Enter TDS Percentage";
    }
    if (kycForm.tdsDetailsTwo && !kycForm.tdsPercentageTwo) {
      validationErrors.tdsPercentageTwoError = "Enter TDS Percentage";
    }
    if (kycForm.tdsDetailsOne && kycForm.tdsPercentageOne && !kycForm.tan) {
      validationErrors.tanError = "Enter TAN number";
    }
    if (kycForm.tdsDetailsTwo && kycForm.tdsPercentageTwo && !kycForm.tan) {
      validationErrors.tanError = "Enter TAN number";
    }
    if (!this.state.isSupplier && !this.state.customerTypes.length > 0) {
      validationErrors.customerTypesError = "Select Customer Type";
    }
    if (kycForm.tan && !validate.isValidTAN(kycForm.tan)) {
      validationErrors.tanError = "Enter Valid TAN";
    }

    if (!kycForm.gstTaxPayerDetails) {
      validationErrors.gstTaxPayerDetailsError = "Select Tax Payer Type";
    }
    if (
      kycForm.gstinStatus === "0" &&
      (kycForm.gstTaxPayerDetails === "05" ||
        kycForm.gstTaxPayerDetails === "02")
    ) {
      validationErrors.gstTaxPayerDetailsError =
        "Select Different Tax Payer Type!";
    }
    if (
      kycForm.gstinStatus === "1" &&
      kycForm.gstTaxPayerDetails !== "05" &&
      kycForm.gstTaxPayerDetails !== "02"
    ) {
      validationErrors.gstTaxPayerDetailsError =
        "Select Different Tax Payer Type!";
    }
    if (kycForm.gstTaxPayerDetails === "01" && !kycForm.sezFrmDate) {
      validationErrors.sezFromDateError = "Enter SEZ From Date";
    } else if (
      kycForm.gstTaxPayerDetails === "01" &&
      !validate.isValidDateFormat(kycForm.sezFrmDate)
    ) {
      validationErrors.sezFromDateError =
        "Enter From Date in dd-mm-yyyy format";
    }
    if (kycForm.gstTaxPayerDetails === "01" && !kycForm.sezToDate) {
      validationErrors.sezToDateError = "Enter SEZ  To Date";
    } else if (
      kycForm.gstTaxPayerDetails === "01" &&
      !validate.isValidDateFormat(kycForm.sezToDate)
    ) {
      validationErrors.sezToDateError = "Enter To Date in dd-mm-yyyy format";
    } else if (
      kycForm.gstTaxPayerDetails === "01" &&
      StringToDate(kycForm.sezFrmDate) > StringToDate(kycForm.sezToDate)
    ) {
      validationErrors.sezFromDateError =
        "SEZ From Date must be Lesser Than SEZ To Date";
    }
    if (!kycForm.typeOfIndustry) {
      validationErrors.typeOfIndustryError = "Enter type of Industry";
    }
    if (!kycForm.legalStatus) {
      validationErrors.legalStatusError = "Select Legal Status";
    }
    if (!kycForm.supplPremises) {
      validationErrors.supplPremisesError =
        "Select " + this.state.displayLabel + " Premises";
    }

    if (!kycForm.department) {
      validationErrors.departmentError = "Select Department";
    }
    if (!kycForm.gstinStatus) {
      validationErrors.gstnStatusError = "Select GSTIN status";
    }

    if (this.state.isSupplier) {
      if (!kycForm.taxExemption) {
        validationErrors.taxExemptionError = "Select Tax Exemption";
      }
      if (!kycForm.annualSales) {
        validationErrors.annualSalesError = "Enter Annual Sales";
      }
      if (
        !kycForm.annualSales &&
        !validateReg.numberValid.test(kycForm.annualSales)
      ) {
        validationErrors.annualSalesError =
          "Enter Valid Value For Annual Sales";
      }
      if (!kycForm.noOfEmployees) {
        validationErrors.noOfEmployeesError = "Enter Number Of Employees";
      }
      if (
        !kycForm.noOfEmployees &&
        !validateReg.numberValid.test(kycForm.noOfEmployees)
      ) {
        validationErrors.noOfEmployeesError = "Enter Number Of Employees";
      }
      if (!kycForm.companyType) {
        validationErrors.companyTypeError = "Select Company Type";
      }
      if (
        (kycForm.companyType === "1" ||
          kycForm.companyType === "2" ||
          kycForm.companyType === "3") &&
        !kycForm.msmeRegNo
      ) {
        validationErrors.msmeRegNoError = "Enter MSME REG No";
      }
      if (!kycForm.taxLowerRate) {
        validationErrors.taxLowerRateError = "Select Tax Lower Rate";
      }
      if (!kycForm.gstCompScheme) {
        validationErrors.gstCompSchemeError = "Select GSTIN Composition Scheme";
      }
    }
    let chkFileUploads = this.validateFileUploads();
    if (chkFileUploads.length > 0) {
      validationErrors.fileUploadTypeError = chkFileUploads;
    }
    return validationErrors;
  };

  validateFileUploads = () => {
    let fileTypes = this.state.fileUploadTypesData;
    let fileTypeCodes = fileTypes.map((file) => file.code);
    let fileUploadTypeError = [];
    let uploadedFiles = this.state.files.map((file) => file.fileType);
    let notUploaded = [];
    notUploaded = fileTypeCodes.filter(function (obj) {
      return uploadedFiles.indexOf(obj) === -1;
    });

    for (var i = 0; i < notUploaded.length; i++) {
      if (
        notUploaded[i] === "ROC Regn Number" &&
        this.state.kycForm.rocRegnNo
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        notUploaded[i] === "Trade License Number" &&
        this.state.kycForm.tradeLicenseNo
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        notUploaded[i] === "Tax Lower Rate" &&
        this.state.kycForm.taxLowerRate === "Y"
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        notUploaded[i] === "Tax Exemption" &&
        this.state.kycForm.taxExemption === "Y"
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (notUploaded[i] === "PAN") {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        notUploaded[i] === "SEZ Certificate" &&
        this.state.kycForm.gstTaxPayerDetails === "01"
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (this.state.kycForm.tan && notUploaded[i] === "TAN") {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        notUploaded[i] === "GST Composition Scheme" &&
        this.state.kycForm.gstCompScheme === "Y"
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        !this.state.isSupplier &&
        this.state.kycForm.tdsDetailsOne &&
        notUploaded[i] === "TDS Declaration Form"
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        !this.state.isSupplier &&
        this.state.kycForm.tdsDetailsTwo &&
        notUploaded[i] === "TDS Declaration Form"
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        !this.state.isSupplier &&
        this.state.customerTypes.indexOf("CHA") >= 0 &&
        notUploaded[i] === "CHA License"
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        !this.state.isSupplier &&
        notUploaded[i] === "IEC Copy" &&
        (this.state.customerTypes.indexOf("IMPORTER") >= 0 ||
          this.state.customerTypes.indexOf("EXPORTER") >= 0)
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        notUploaded[i] === "GST Terms For Registered Vendors" &&
        this.state.isSupplier &&
        this.state.kycForm.gstinStatus === "0"
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        notUploaded[i] === "MSME Regn Number" &&
        this.state.kycForm.msmeRegNo
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        notUploaded[i] === "GST undertaking for non-registration" &&
        this.state.kycForm.gstinStatus === "1" &&
        (this.state.kycForm.gstTaxPayerDetails === "05" ||
          this.state.kycForm.gstTaxPayerDetails === "02")
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      } else if (
        notUploaded[i] === "GSTIN Registration Certificate" &&
        this.state.kycForm.gstinStatus === "0" &&
        this.state.kycForm.gstTaxPayerDetails !== "05" &&
        this.state.kycForm.gstTaxPayerDetails !== "02"
      ) {
        fileUploadTypeError.push(notUploaded[i]);
      }
    }
    return fileUploadTypeError;
  };

  onToggle = (e, index) => {
    let checkedValue = e.target.value;
    let isChecked = e.target.checked;

    let items = this.state.customerTypes;
    let isCheckedVal = items.indexOf(checkedValue) >= 0 ? true : false;
    if (items.length > 0 && isCheckedVal && !isChecked) {
      items = items.filter(function (value, index, item) {
        return value !== checkedValue;
      });
    } else {
      items.push(checkedValue);
    }
    let chaCode = false;
    if (items.indexOf("CHA") >= 0) {
      chaCode = true;
      this.setState({
        kycForm: {
          ...this.state.kycForm,
          custCode: "",
          showCHAMsg: true,
        },
      });
    } else {
      this.setState({
        kycForm: {
          ...this.state.kycForm,
          custCode: this.state.custCodeExceptCHA,
          showCHAMsg: false,
        },
      });
    }
    this.setState({
      customerTypes: items,
      enableCode: chaCode,
      dirty: true,
    });
  };
  async fileUpload(e) {
    let validationErrors = Object.assign({}, this.state.validationErrors);
    this.setState({ validationErrors: "" });

    if (this.state.kycForm.fileUploadType) {
      let fileNames = [];
      let fileCount = e.target.files.length;
      if (fileCount > 0) {
        for (let i = 0; i < e.target.files.length; i++) {
          var filereader = new FileReader();
          let filesObj = {};
          Object.assign(filesObj, e.target.files);
          const blob = filesObj[i].slice(0, 4);
          filereader.readAsArrayBuffer(blob);

          filereader.onloadend = async (evt) => {
            let isValidFileExtension = validateFileExt.validateFileExtensionMimeType(
              evt
            );
            if (isValidFileExtension) {
              let duplicatefile = this.state.files.filter((item) => {
                return (
                  item.name == filesObj[i].name &&
                  item.fileType == this.state.kycForm.fileUploadType
                );
              });
              if (duplicatefile.length > 0) {
                validationErrors.fileTypeError =
                  "Found duplicate file for document upload type";
                this.setState({
                  validationErrors: validationErrors,
                  file: {},
                });
                return;
              }
              let fileId = uuidv4();
              fileNames = [
                {
                  fileId: fileId,
                  name: filesObj[i].name,
                  fileType: this.state.kycForm.fileUploadType,
                },
              ];
              formData = new FormData();
              var file = filesObj[i];
              formData.append("file", file);
              formData.append("filename", fileId + "_" + filesObj[i].name);
              formData.append("fileType", this.state.kycForm.fileUploadType);
              formData.append("userId", this.state.clientId);

              // addressService.uploadFile(formData);
              let { response, err } = await bankService.uploadFile(formData);
              if (err) {
                this.setState({
                  fileUploadError:
                    "File limit has exceeded, Please upload file size of maximum 2 MB",
                });
              } else {
                this.setState({
                  fileUploadError: "",
                  files: [...this.state.files, ...fileNames],
                  dirty: true,
                });
              }
              document.getElementById("docs").value = "";
            } else {
              validationErrors.fileTypeError = messages.fileExtensionError;
              this.setState({
                validationErrors: validationErrors,
                file: {},
              });
            }
          };
        }
      }
    } else {
      validationErrors.fileTypeError = "Select document upload type";
      this.setState({
        validationErrors: validationErrors,
        file: {},
      });
    }
  }

  async deleteFile(name, id) {
    var that = this;
    var config = {
      message: "Are you sure you want to delete this file?",
      onYesClick: async function () {
        let filesAfterDelete = [];
        if (that.state.files.length > 0) {
          filesAfterDelete = that.state.files.filter((ele) => {
            return ele.fileId !== id;
          });
        }
        let objDelFile = {
          fileId: id,
          name: name,
          clientId: that.state.clientId,
        };

        await addressService.deleteFile(objDelFile);
        let res = await kycService.deleteCustFile(objDelFile);
        if (!res.err) {
          that.setState({
            files: filesAfterDelete,
            deletedFiles: [...that.state.deletedFiles],
          });
        } else {
        }
      },
      onNoClick: null,
    };
    Utility.showConfirm(config);
  }

  downloadFile = async (name, id) => {
    downloadFile(this, name, id);
  };

  // onChangeTDS = (e) => {
  //   const name = e.target.name;
  //   if (!e.target.value) {
  //     if (e.target.name === "tdsDetailsOne") {
  //       this.setState({
  //         kycForm: {
  //           ...this.state.kycForm,
  //           tdsPercentageOne: "",
  //           [name]: "",
  //         },
  //         dirty: true,
  //       });
  //       return;
  //     } else if (e.target.name === "tdsDetailsTwo") {
  //       this.setState({
  //         kycForm: {
  //           ...this.state.kycForm,
  //           tdsPercentageTwo: "",
  //           [name]: "",
  //         },
  //         dirty: true,
  //       });
  //       return;
  //     } else {
  //       this.setState({
  //         kycForm: {
  //           ...this.state.kycForm,
  //           [name]: "",
  //         },
  //         dirty: true,
  //       });
  //       return;
  //     }
  //   }

  //   const value = e.target.value;
  //   let tdsPerc = this.state.tdsDetails.filter((tds) => tds.code === value)[0];

  //   if (e.target.name === "tdsDetailsOne") {
  //     this.setState({
  //       kycForm: {
  //         ...this.state.kycForm,
  //         tdsPercentageOne: tdsPerc.description,
  //         // tdsPercentageOne: "",
  //         [name]: value,
  //       },
  //       dirty: true,
  //     });
  //   }

  //   if (e.target.name === "tdsDetailsTwo") {
  //     this.setState({
  //       kycForm: {
  //         ...this.state.kycForm,
  //         tdsPercentageTwo: tdsPerc.description,
  //         [name]: value,
  //       },
  //       dirty: true,
  //     });
  //   }
  // };

  onChangeTDS = (e) => {
    const name = e.target.name;
    if (!e.target.value) {
      if (e.target.name === "tdsDetailsOne") {
        this.setState({
          kycForm: {
            ...this.state.kycForm,
            tdsPercentageOne: "",
            [name]: "",
          },
          dirty: true,
        });
        return;
      } else if (e.target.name === "tdsDetailsTwo") {
        this.setState({
          kycForm: {
            ...this.state.kycForm,
            tdsPercentageTwo: "",
            [name]: "",
          },
          dirty: true,
        });
        return;
      } else {
        this.setState({
          kycForm: {
            ...this.state.kycForm,
            [name]: "",
          },
          dirty: true,
        });
        return;
      }
    }

    const value = e.target.value;
    let tdsPerc = this.state.tdsDetails.filter((tds) => tds.code === value)[0];

    if (e.target.name === "tdsDetailsOne") {
      this.setState({
        kycForm: {
          ...this.state.kycForm,
          tdsPercentageOne: tdsPerc.description,
          [name]: value,
        },
        dirty: true,
      });
    }
    if (e.target.name === "tdsDetailsTwo") {
      this.setState({
        kycForm: {
          ...this.state.kycForm,
          tdsPercentageTwo: tdsPerc.description,
          [name]: value,
        },
        dirty: true,
      });
    }
  };

  creatOptions = (obj) => {
    let isDisabled = false;
    let options =
      obj.length > 0 &&
      obj.map((item, index) => {
        return (
          <option key={item.code} value={item.code} disabled={isDisabled}>
            {item.name}
          </option>
        );
      });

    return options;
  };

  checkStatus() {
    kycStatus = this.state.kycForm.kycStatus
      ? this.state.kycForm.kycStatus.toLowerCase()
      : "";
    if (this.state.disableApproveButton) {
      disableApproveButton = true;
      disableRejectButton = true;
    } else if (
      kycStatus !== "confirmed" &&
      (this.role === "02" || this.role === "04")
    ) {
      disableApproveButton = true;
      disableRejectButton = true;
    } else {
      disableApproveButton =
        kycStatus === "approved" || kycStatus === "rejected" ? true : false;
      disableRejectButton =
        (this.role === "03" && this.state.kycForm.kycStatus === "CONFIRMED") ||
          (this.role === "02" && this.state.kycForm.kycStatus === "APPROVED")
          ? true
          : false;
    }
    disableConfirmButton =
      kycStatus === "confirmed" || disableApproveButton ? true : false;
  }

  async generateCSXml(flag) {
    Loader.showLoader();
    let generateXML = {};
    generateXML.userType = this.props.clientType;
    generateXML.clientId = this.state.clientId;
    let { response, err } = await xmlService.generateCSXml(generateXML);
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      this.setState(
        {
          regenerateMsg: response.data.msg,
        },
        () => {
          setTimeout(() => this.setState({ regenerateMsg: "" }), 1000);
        }
      );
    }
  }

  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    let kycForm = Object.assign({}, this.state.kycForm);
    let fileUploadTypeOptions = this.creatOptions(
      this.state.fileUploadTypesData
    );
    let departments = [];
    let deptCount = this.state.deptData.length;

    for (let i = 0; i < deptCount; ++i) {
      let dept = this.state.deptData[i];
      if (this.state.isSupplier) {
        if (dept.customerType === "C" || dept.customerType === "DC") {
          departments.push(dept);
        }
      } else {
        if (dept.customerType === "D" || dept.customerType === "DC") {
          departments.push(dept);
        }
      }
    }

    let files = [];
    if (this.state.files !== null) {
      if (this.state.files.length > 0) {
        files = this.state.files.map((element, index) => {
          return (
            <tr key={index}>
              <td>{element.fileType}</td>
              <td>{element.name}</td>
              <td className="text-center">
                {!this.state.disableKyc ? (
                  <span alt="Delete" className="">
                    <a
                      onClick={this.deleteFile.bind(
                        this,
                        element.fileId + "_" + element.name,
                        element.fileId
                      )}
                    >
                      <i className="text-danger  fas fa-trash-alt"></i>
                    </a>
                  </span>
                ) : null}
              </td>
              <td className="text-center">
                <span alt="Download" className="">
                  <a
                    onClick={this.downloadFile.bind(
                      this,
                      element.name,
                      element.fileId
                    )}
                  >
                    <i className="text-info  fa fa-download"></i>{" "}
                  </a>
                </span>
              </td>
            </tr>
          );
        });
      }
    }
    let custTypesArr = CUSTOMERTYPES;
    let custTypeCheckBxs =
      custTypesArr.length > 0 &&
      custTypesArr.map((cType, index) => {
        return (
          <label className="mr-3" key={cType}>
            <input
              className="mr-1"
              name={cType}
              checked={
                this.state.customerTypes.indexOf(cType) >= 0 ? true : false
              }
              value={cType}
              type="checkbox"
              onChange={(e) => this.onToggle(e)}
            />
            {cType}
          </label>
        );
      });
    userType = this.props.clientType;
    let internalUser = this.state.loginUserType;
    let link = "";
    if (userType === GSTIN_LinkValid) {
      link = (
        <a
          href="https://services.gst.gov.in/services/searchtp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="icon-link"></i>
        </a>
      );
    } else {
      link = "";
    }
    this.checkStatus();

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            <button
              className="btn  btn-info btn-xs float-right"
              title="Download PDF"
              onClick={this.downloadPdf.bind(
                this,
                this.state.clientId,
                this.state.userType
              )}
            >
              <i className="fa fa-download text-black"></i> PDF
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            {this.state.showSuccess && (
              <span className="msg-style-success">{this.state.succesMsg}</span>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            {this.state.showStatus && (
              <span className="msg-style-success">
                The KYC has been {this.state.status}
              </span>
            )}
          </div>
        </div>
        <h3 style={{ textAlign: "center", textDecoration: "underline" }}>
          {userType === "Customer" ? "CUSTOMER" : "SUPPLIER"} DETAILS
        </h3>
        <form onSubmit={this.handleSubmit} id="formClient">
          <label htmlFor="">
            <strong> General Details :</strong>{" "}
          </label>
          <div className="field-wrapper mt-2">
            <div className="row">
              {!this.state.isSupplier && (
                <div className="col-sm-4">
                  <div className="form-group">
                    <label className="" htmlFor="Name">
                      {this.state.displayLabel} Code
                      <span className="mandatory">*</span>
                    </label>
                    <input
                      className={
                        this.state.validationErrors.custNameError
                          ? "is-invalid form-control"
                          : "form-control"
                      }
                      type="text"
                      placeholder={
                        userType === "Customer"
                          ? "Enter Customer Code"
                          : "Enter Supplier Code"
                      }
                      name="custCode"
                      value={this.state.kycForm.custCode || ""}
                      onChange={this.onChange}
                      maxLength="25"
                      autoComplete="off"
                      disabled={
                        (!this.state.enableCode &&
                          internalUser === "Customer") ||
                        internalUser === "Supplier"
                      }
                      onKeyPress={this.onKeyPressNumber}
                    />
                    <span className="error-msg">
                      {this.state.validationErrors.custNameError}
                    </span>
                    {kycForm.showCHAMsg && (
                      <span className="">Please update your CHA number</span>
                    )}
                  </div>
                </div>
              )}
              <div className="col-sm-4">
                <DropDown
                  label="Department"
                  name="department"
                  required="true"
                  value={this.state.kycForm.department || ""}
                  error={this.state.validationErrors.departmentError}
                  onChange={this.onChange}
                  defaultItem={defaultListItem}
                  list={departments}
                  valProp="deptName"
                  textProp="deptName"
                />
              </div>
              <div className="col-sm-4">
                 <TextBox
                    type="text"
                    label="Contact Person"
                    required="true"
                    value={this.state.kycForm.contactPerson || ""}
                    name="contactPerson"
                    error={this.state.validationErrors.contactPersonError}
                    onChange={this.onChange}
                    maxLength="100"
                  />
              </div>
              {!this.state.isSupplier && (
                <div className="col-sm-8">
                  <div className="row pt-2 mt-20">
                    <h6 className="col-sm-12">
                      Customer Type<span className="mandatory">*</span> &nbsp;{" "}
                      <span className="error-msg">
                        {this.state.validationErrors.customerTypesError}
                      </span>
                    </h6>
                    <div className="col-sm-12">{custTypeCheckBxs}</div>
                  </div>
                </div>
              )}
              {this.state.kycForm.finLedgerCode && (
                <div className="col-sm-4">
                  <div className="row pt-2 mt-20">
                    <h6 className="col-sm-12">Finance Ledger Code &nbsp;</h6>
                    <div className="col-sm-12">
                      {this.state.kycForm.finLedgerCode}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label className="" htmlFor="contactNo">
                    Contact Number &nbsp;{" "}
                    <span className="error-msg">
                      {this.state.validationErrors.contactNoError}
                    </span>
                  </label>
                  <input
                    className={
                      this.state.validationErrors.contactNoError
                        ? "is-invalid form-control"
                        : "form-control"
                    }
                    type="text"
                    placeholder="Enter Contact Number"
                    name="contactNo"
                    value={this.state.kycForm.contactNo || ""}
                    onChange={this.onChange}
                    maxLength="10"
                    autoComplete="off"
                    onKeyPress={this.onKeyPressNumber}
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label className="" htmlFor="pan">
                    PAN Number<span className="mandatory">*</span>&nbsp;{" "}
                    <span className="error-msg">
                      {this.state.validationErrors.panError}
                    </span>
                  </label>
                  <input
                    className={
                      this.state.validationErrors.panError
                        ? "is-invalid form-control"
                        : "form-control"
                    }
                    type="text"
                    maxLength="10"
                    placeholder="Enter PAN Number"
                    name="pan"
                    value={this.state.kycForm.pan || ""}
                    onChange={this.onChange}
                    autoComplete="off"
                    disabled={internalUser !== "InternalUser"}
                  />
                </div>
              </div>
              <div className="col-sm-4">
                {this.state.isSupplier && (
                  <div className="form-group">
                    <label className="" htmlFor="dateOfIncorporation">
                      Date Of Incorporation<span className="mandatory">*</span>
                      &nbsp;{" "}
                      <span className="error-msg">
                        {this.state.validationErrors.incorporationError}
                      </span>
                    </label>
                    <DatePicker
                      className={
                        this.state.validationErrors.incorporationError
                          ? "is-invalid form-control"
                          : "form-control"
                      }
                      dateFormat="dd-MM-yyyy"
                      disabled={this.state.isDatePickerDisable}
                      maxDate={new Date()}
                      maxLength="10"
                      placeholderText="dd-mm-yyyy"
                      name="dateOfIncorporation"
                      placeholder="dd-mm-yyyy"
                      selected={this.state.kycForm.dateOfIncorporation1 || null}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      onKeyDown={this.onKeyPressDateValidation}
                      onChange={this.handleChange.bind(this, "dateOfIncorporation")}
                      // onChangeRaw={this.onKeyPressDate}
                      autoComplete="off"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label className="" htmlFor="Customer">
                    {this.state.displayLabel} Name
                    <span className="error-msg">
                      {this.state.validationErrors.customerError}
                    </span>
                    <span className="mandatory">*</span>
                  </label>
                  <input
                    className={
                      this.state.validationErrors.customerError
                        ? "is-invalid form-control"
                        : "form-control"
                    }
                    type="text"
                    placeholder={
                      userType === "Customer"
                        ? "Enter Customer Name"
                        : "Enter Supplier Name"
                    }
                    name="customer"
                    value={this.state.kycForm.customer || ""}
                    onChange={this.onChange}
                    maxLength="150"
                    autoComplete="off"
                    disabled={internalUser !== "InternalUser"}
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <TextBox
                  type="text"
                  label="Operations Email"
                  required="true"
                  value={this.state.kycForm.operationsEmails || ""}
                  name="operationsEmails"
                  error={this.state.validationErrors.operationsEmailsError}
                  onChange={this.onChange}
                  maxLength="250"
                />
              </div>
              <div className="col-sm-4">
                <TextBox
                  type="text"
                  label="Finance Email"
                  required="true"
                  value={this.state.kycForm.finMailIds || ""}
                  name="finMailIds"
                  error={this.state.validationErrors.finMailIdsError}
                  onChange={this.onChange}
                  maxLength="250"
                />
              </div>
            </div>
          </div>
          <label className="mt-3" htmlFor="">
            <strong>Address Details : </strong>
          </label>
          <div className="field-wrapper">
            <div className="row">
              <div className="col-sm-4">
                <TextBox
                  type="text"
                  label="Address Line 1"
                  required="true"
                  value={this.state.kycForm.addressLineOne || ""}
                  name="addressLineOne"
                  error={this.state.validationErrors.addressLineOneError}
                  onChange={this.onChange}
                  maxLength="30"
                />
              </div>
              <div className="col-sm-4">
                <TextBox
                  type="text"
                  label="Address Line 2"
                  required="true"
                  value={this.state.kycForm.addressLineTwo || ""}
                  name="addressLineTwo"
                  error={this.state.validationErrors.addressLineTwoError}
                  onChange={this.onChange}
                  maxLength="30"
                />
              </div>
              <div className="col-sm-4">
                <TextBox
                  type="text"
                  label="Address Line 3"
                  value={this.state.kycForm.addressLineThree || ""}
                  name="addressLineThree"
                  onChange={this.onChange}
                  maxLength="30"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <TextBox
                  type="text"
                  label="Address Line 4"
                  value={this.state.kycForm.addressLineFour || ""}
                  name="addressLineFour"
                  onChange={this.onChange}
                  maxLength="30"
                />
              </div>
              <div className="col-sm-3">
                <TextBox
                  type="text"
                  label="Town/City"
                  required="true"
                  value={this.state.kycForm.city || ""}
                  name="city"
                  error={this.state.validationErrors.cityError}
                  onChange={this.onChange}
                  maxLength="100"
                />
              </div>
              <div className="col-sm-3">
                <DropDown
                  label="State"
                  name="state"
                  required="true"
                  value={this.state.kycForm.state || ""}
                  error={this.state.validationErrors.stateError}
                  onChange={this.onChange}
                  defaultItem={defaultListItem}
                  list={this.state.stateData}
                  valProp="code"
                  textProp="name"
                />
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="" htmlFor="Customer">
                    Postal Code<span className="mandatory">*</span> &nbsp;{" "}
                    <span className="error-msg">
                      {this.state.validationErrors.postalCodeError}
                    </span>
                  </label>
                  <input
                    className={
                      this.state.validationErrors.postalCodeError
                        ? "is-invalid form-control"
                        : "form-control"
                    }
                    type="text"
                    maxLength="6"
                    placeholder="Enter Postal Code"
                    name="postalCode"
                    value={this.state.kycForm.postalCode || ""}
                    onKeyPress={this.onKeyPressNumber}
                    onChange={this.onChange}
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* TDS Details */}
          <label className="mt-3" htmlFor="">
            <strong>TDS Details : </strong>
          </label>
          <div className="field-wrapper mt-2">
            <div className="row">
              {!this.state.isSupplier && (
                <React.Fragment>
                  <div className="col-sm-3">
                    <DropDown
                      label="TDS"
                      name="tdsDetailsOne"
                      required={this.state.isSupplier}
                      error={this.state.validationErrors.tdsDetailsOneError}
                      value={this.state.kycForm.tdsDetailsOne || ""}
                      onChange={this.onChangeTDS}
                      defaultItem={defaultListItem}
                      list={this.state.tdsDetails || []}
                      valProp="code"
                      textProp="name"
                    />
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <label className="" htmlFor="tdsPercentageOne">
                        TDS Percentage
                        {this.state.isSupplier && (
                          <span className="mandatory">*</span>
                        )}{" "}
                        &nbsp;{" "}
                        <span className="error-msg">
                          {this.state.validationErrors.tdsPercentageOneError}
                        </span>
                      </label>
                      <br />
                      <input
                        className={
                          this.state.validationErrors.tdsPercentageOneError
                            ? "is-invalid form-control"
                            : "form-control"
                        }
                        type="text"
                        placeholder="Enter TDS Percentage"
                        name="tdsPercentageOne"
                        value={this.state.kycForm.tdsPercentageOne || ""}
                        onChange={this.onChange}
                        autoComplete="off"
                        disabled={
                          this.state.kycForm.tdsDetailsOne == "" ||
                          this.state.kycForm.tdsDetailsOne == undefined
                        }
                      />
                    </div>
                  </div>

                  <div className="col-sm-3">
                    <DropDownGroup
                      label="TDS"
                      name="tdsDetailsTwo"
                      required={this.state.isSupplier}
                      error={this.state.validationErrors.tdsDetailsTwoError}
                      value={this.state.kycForm.tdsDetailsTwo || ""}
                      onChange={this.onChangeTDS}
                      defaultItem={defaultListItem}
                      list={this.state.tdsDetails || []}
                      valProp="code"
                      textProp="name"
                      customhref="/downloads/tds_deduction_undertaking.docx"
                      customTitle="Sample TDS deduction undertanking on company letter head"
                    />
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <label className="" htmlFor="pan">
                        TDS Percentage
                        <span className="error-msg">
                          {this.state.validationErrors.tdsPercentageTwoError}
                        </span>
                      </label>
                      <br />
                      <input
                        className={
                          this.state.validationErrors.tdsPercentageTwoError
                            ? "is-invalid form-control"
                            : "form-control"
                        }
                        type="text"
                        placeholder="Enter TDS Percentage"
                        name="tdsPercentageTwo"
                        value={this.state.kycForm.tdsPercentageTwo || ""}
                        onChange={this.onChange}
                        autoComplete="off"
                        disabled={
                          this.state.kycForm.tdsDetailsTwo == "" ||
                          this.state.kycForm.tdsDetailsTwo == undefined
                        }
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}

              <div className="col-sm-3">
                <div className="form-group">
                  <label className="" htmlFor="tan">
                    TAN Number &nbsp;{" "}
                    <span className="error-msg">
                      {this.state.validationErrors.tanError}
                    </span>
                  </label>
                  <input
                    className={
                      this.state.validationErrors.tanError
                        ? "is-invalid form-control"
                        : "form-control"
                    }
                    type="text"
                    maxLength="10"
                    placeholder="Enter TAN Number"
                    name="tan"
                    value={this.state.kycForm.tan || ""}
                    onChange={this.onChange}
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* GST Related */}
          <label className="mt-2" htmlFor="">
            <strong>GST Details </strong>
          </label>
          <div className="field-wrapper mt-2">
            <div className="row">
              <div className="col-sm-4">
                <DropDown
                  label="Tax Payer Type"
                  name="gstTaxPayerDetails"
                  required={true}
                  error={this.state.validationErrors.gstTaxPayerDetailsError}
                  value={this.state.kycForm.gstTaxPayerDetails || ""}
                  onChange={this.onChange}
                  defaultItem={defaultListItem}
                  list={this.state.taxPayerTypesData || []}
                  valProp="code"
                  textProp="name"
                />
              </div>
              <div className="col-sm-4">
                <DropDownGroup
                  label="GSTIN Status"
                  name="gstinStatus"
                  required={true}
                  error={this.state.validationErrors.gstnStatusError}
                  value={this.state.kycForm.gstinStatus || ""}
                  onChange={this.onChange}
                  defaultItem={defaultListItem}
                  list={this.state.gstStatusData || []}
                  valProp="code"
                  textProp="name"
                  customhref={
                    this.state.isSupplier &&
                      this.state.kycForm.gstinStatus === "0"
                      ? "/downloads/gst_terms_of_engagement_for_registered_vendors.docx"
                      : "/downloads/gst_undertaking_for_non_registration.docx"
                  }
                  customTitle={
                    this.state.isSupplier &&
                      this.state.kycForm.gstinStatus === "0"
                      ? "Sample GST terms of engagement for registered vendors"
                      : "Sample GST undertaking for non-registration"
                  }
                />
              </div>
              {this.state.isSupplier && (
                <div className="col-sm-4">
                  <DropDown
                    label="Tax Exemption"
                    name="taxExemption"
                    required={true}
                    error={this.state.validationErrors.taxExemptionError}
                    value={this.state.kycForm.taxExemption || ""}
                    onChange={this.onChange}
                    defaultItem={defaultListItem}
                    list={this.state.taxExemptionData || []}
                    valProp="code"
                    textProp="name"
                  />
                </div>
              )}
              {this.state.showGSTINNo && (
                <div className="col-sm-4">
                  <div className="form-group">
                    <label className="col-form-label" htmlFor="Customer">
                      GSTIN Number<span className="mandatory">*</span> &nbsp;{" "}
                      <span className="error-msg">
                        {this.state.validationErrors.gstinNoError}
                      </span>{" "}
                      {link}
                    </label>
                    <input
                      disabled={this.state.disableGSTIN}
                      className={
                        this.state.validationErrors.gstinNoError
                          ? "is-invalid form-control"
                          : "form-control"
                      }
                      type="text"
                      placeholder="Enter GSTIN number"
                      name="gstinNo"
                      value={this.state.kycForm.gstinNo || ""}
                      onChange={this.onChange}
                      maxLength="15"
                      autoComplete="off"
                    />
                  </div>
                </div>
              )}
              {this.state.showSEZFrmToDate && (
                <React.Fragment>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="" htmlFor="sezFrmDate">
                        SEZ From Date<span className="mandatory">*</span>&nbsp;
                      </label>
                      <DatePicker
                        className={
                          this.state.validationErrors.sezFromDateError
                            ? "is-invalid form-control"
                            : "form-control"
                        }
                        dateFormat="dd-MM-yyyy"
                        maxLength="10"
                        placeholderText="dd-mm-yyyy"
                        name="sezFrmDate"
                        placeholder="dd-mm-yyyy"
                        onKeyDown={this.onKeyPressDateValidation}
                        selected={this.state.kycForm.sezFrmDate1}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        onChange={this.handleChange.bind(this, "sezFrmDate")}
                        // onChangeRaw={this.onKeyPressDate}
                        autoComplete="off"
                      />
                      <span className="error-msg">
                        {this.state.validationErrors.sezFromDateError}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="" htmlFor="sezToDate">
                        SEZ To Date&nbsp; <span className="mandatory">*</span>
                        &nbsp;
                      </label>
                      <DatePicker
                        className={
                          this.state.validationErrors.sezToDateError
                            ? "is-invalid form-control"
                            : "form-control"
                        }
                        minDate={this.state.kycForm.sezFrmDate1}
                        dateFormat="dd-MM-yyyy"
                        maxLength="10"
                        placeholderText="dd-mm-yyyy"
                        name="sezToDate"
                        placeholder="dd-mm-yyyy"
                        onKeyDown={this.onKeyPressDateValidation}
                        selected={this.state.kycForm.sezToDate1}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        onChange={this.handleChange.bind(this, "sezToDate")}
                        // onChangeRaw={this.onKeyPressDate}
                        autoComplete="off"
                      />
                      <span className="error-msg">
                        {this.state.validationErrors.sezToDateError}
                      </span>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
          <React.Fragment>
            <label className="mt-2" htmlFor="">
              <strong>Company Details : </strong>
            </label>
            <div className="field-wrapper mt-2">
              <div className="row">
                {this.state.isSupplier && (
                  <React.Fragment>
                    <div className="col-md-4">
                      <TextBox
                        type="text"
                        label="Website"
                        value={this.state.kycForm.website || ""}
                        name="website"
                        onChange={this.onChange}
                        maxLength="100"
                      />
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="" htmlFor="Customer">
                          Annual Sales(Last FY){" "}
                          <span className="mandatory">*</span> &nbsp;{" "}
                          <span className="error-msg">
                            {this.state.validationErrors.annualSalesError}
                          </span>
                        </label>
                        <input
                          className={
                            this.state.validationErrors.annualSalesError
                              ? "is-invalid form-control"
                              : "form-control"
                          }
                          type="number"
                          maxLength="10"
                          placeholder="Annual Sales"
                          name="annualSales"
                          value={this.state.kycForm.annualSales || ""}
                          onChange={this.onChange}
                          onKeyPress={this.onKeyPressNumber}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="" htmlFor="Customer">
                          No. of Employees<span className="mandatory">*</span>
                          &nbsp;{" "}
                          <span className="error-msg">
                            {this.state.validationErrors.noOfEmployeesError}
                          </span>
                        </label>
                        <input
                          className={
                            this.state.validationErrors.noOfEmployeesError
                              ? "is-invalid form-control"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={this.onKeyPressNumber}
                          maxLength="10"
                          placeholder="No. Of Employees"
                          name="noOfEmployees"
                          value={this.state.kycForm.noOfEmployees || ""}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <DropDown
                        label="Company Type"
                        name="companyType"
                        required={true}
                        error={this.state.validationErrors.companyTypeError}
                        value={this.state.kycForm.companyType || ""}
                        onChange={this.onChange}
                        defaultItem={defaultListItem}
                        list={this.state.companyTypeData || []}
                        valProp="code"
                        textProp="name"
                      />
                    </div>
                    {this.state.showNAReasonComp ? (
                      <div className="col-md-4">
                        <TextBox
                          type="text"
                          label="Reason (Company Type is Not Applicable)"
                          value={this.state.kycForm.compTypeNAReason || ""}
                          error={
                            this.state.validationErrors.compTypeNAReasonError
                          }
                          name="compTypeNAReason"
                          onChange={this.onChange}
                          maxLength="250"
                        />
                      </div>
                    ) : (
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="" htmlFor="Customer">
                            MSME Reg No &nbsp;{" "}
                            <span className="error-msg">
                              {this.state.validationErrors.msmeRegNoError}
                            </span>
                          </label>
                          <input
                            className={
                              this.state.validationErrors.msmeRegNoError
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            type="text"
                            placeholder="MSME Reg No"
                            name="msmeRegNo"
                            value={this.state.kycForm.msmeRegNo || ""}
                            onChange={this.onChange}
                            maxLength="50"
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    )}

                    <div className="col-md-4">
                      <DropDown
                        label="Tax Lower Rate"
                        name="taxLowerRate"
                        required={true}
                        error={this.state.validationErrors.taxLowerRateError}
                        value={this.state.kycForm.taxLowerRate || ""}
                        onChange={this.onChange}
                        defaultItem={defaultListItem}
                        list={this.state.taxLowerRateData || []}
                        valProp="code"
                        textProp="name"
                      />
                    </div>
                    <div className="col-md-4">
                      <DropDown
                        label="GST Composition Scheme"
                        name="gstCompScheme"
                        required={true}
                        error={this.state.validationErrors.gstCompSchemeError}
                        value={this.state.kycForm.gstCompScheme || ""}
                        onChange={this.onChange}
                        defaultItem={defaultListItem}
                        list={this.state.gstCompSchemeData || []}
                        valProp="code"
                        textProp="name"
                      />
                    </div>
                  </React.Fragment>
                )}
                <React.Fragment>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="" htmlFor="Customer">
                        Type Of Industry<span className="mandatory">*</span>
                        &nbsp;{" "}
                        <span className="error-msg">
                          {this.state.validationErrors.typeOfIndustryError}
                        </span>
                      </label>
                      <input
                        className={
                          this.state.validationErrors.typeOfIndustryError
                            ? "is-invalid form-control"
                            : "form-control"
                        }
                        type="text"
                        placeholder="Type of Industry"
                        name="typeOfIndustry"
                        value={this.state.kycForm.typeOfIndustry || ""}
                        onChange={this.onChange}
                        maxLength="100"
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <DropDown
                      label="Legal Status"
                      name="legalStatus"
                      required={true}
                      error={this.state.validationErrors.legalStatusError}
                      value={this.state.kycForm.legalStatus || ""}
                      onChange={this.onChange}
                      defaultItem={defaultListItem}
                      list={this.state.legalStatusData || []}
                      valProp="code"
                      textProp="name"
                    />
                  </div>
                  <div className="col-md-4">
                    <DropDown
                      label={`${this.state.displayLabel}'s Premises`}
                      name="supplPremises"
                      required={true}
                      error={this.state.validationErrors.supplPremisesError}
                      value={this.state.kycForm.supplPremises || ""}
                      onChange={this.onChange}
                      defaultItem={defaultListItem}
                      list={this.state.supplPremisesData || []}
                      valProp="code"
                      textProp="name"
                    />
                  </div>
                  {this.state.isSupplier && (
                    <>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="" htmlFor="yrsInBusiness">
                            No. of Years In Business
                            <span className="mandatory">*</span>&nbsp;{" "}
                            <span className="error-msg">
                              {this.state.validationErrors.yrsInBusinessError}
                            </span>
                          </label>
                          <input
                            className={
                              this.state.validationErrors.yrsInBusinessError
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            type="text"
                            placeholder="No.of Years In Business"
                            name="yrsInBusiness"
                            maxLength="3"
                            value={this.state.kycForm.yrsInBusiness || ""}
                            onChange={this.onChange}
                            onKeyPress={this.onKeyPressNumber}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="" htmlFor="Customer">
                            ROC Regn No. &nbsp;{" "}
                            <span className="error-msg">
                              {this.state.validationErrors.rocRegnNoError}
                            </span>
                          </label>
                          <input
                            className={
                              this.state.validationErrors.rocRegnNoError
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            type="text"
                            placeholder="ROC Regn No."
                            name="rocRegnNo"
                            value={this.state.kycForm.rocRegnNo || ""}
                            onChange={this.onChange}
                            maxLength="50"
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <TextBox
                          type="text"
                          label="Trade License No."
                          placeholder="Trade License No."
                          value={this.state.kycForm.tradeLicenseNo || ""}
                          error={this.state.validationErrors.tradeLicenseNoError}
                          name="tradeLicenseNo"
                          onChange={this.onChange}
                          maxLength="50"
                        />
                      </div>
                    </>)}
                </React.Fragment>
              </div>
            </div>
          </React.Fragment>
          {/* File Uploads */}
          <label className="mt-3" htmlFor="">
            <strong>File Uploads : </strong>
          </label>
          <div className="field-wrapper mt-2">
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group ">
                  <label className="" htmlFor="fileUploadType">
                    File Upload Type :
                  </label>
                  <select
                    className={
                      this.state.validationErrors.fileUploadTypeError
                        ? "is-invalid form-control"
                        : "form-control"
                    }
                    name="fileUploadType"
                    value={this.state.kycForm.fileUploadType || ""}
                    onChange={this.onChange}
                  >
                    <option key="select" value="">
                      --Select--
                    </option>
                    {fileUploadTypeOptions}
                  </select>
                  {this.state.validationErrors.fileTypeError && (
                    <React.Fragment>
                      <span className="error-msg">
                        {this.state.validationErrors.fileTypeError}
                      </span>
                      <br></br>
                    </React.Fragment>
                  )}
                  {this.state.validationErrors.fileUploadTypeError &&
                    this.state.validationErrors.fileUploadTypeError.length >
                    0 &&
                    this.state.validationErrors.fileUploadTypeError.map(
                      (docType, index) => {
                        return (
                          <React.Fragment key={docType}>
                            <span className="error-msg">
                              *Upload file for {docType}
                            </span>
                            <br></br>
                          </React.Fragment>
                        );
                      }
                    )}
                </div>
              </div>

              <div className="col-sm-3">
                <label className="">
                  File Upload :<span className="mandatory">*</span>
                </label>
                <input
                  type="file"
                  id="docs"
                  multiple
                  size="50"
                  className="form-control"
                  onChange={this.fileUpload}
                  autoComplete="off"
                />
              </div>

              <div className="col-sm-6">
                <label className="">Uploaded Files : </label>
                <table className="table table-striped table-bordered file-list">
                  <tbody>{files}</tbody>
                </table>
              </div>

              {this.state.fileUploadError ? (
                <div className="alert alert-danger ml-3">
                  {this.state.fileUploadError}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 mt-2">
              <div className="form-group text-right">
                <input
                  type="submit"
                  className="btn btn-info mr-2 rounded-0"
                  value="Save"
                />
                <input
                  type="button"
                  className="btn btn-primary  mr-2 rounded-0"
                  value="Save and Next"
                  onClick={this.handleSubmit.bind(this, "next")}
                />
                {internalUser !== "InternalUser" ? (
                  <input
                    type="button"
                    className="btn btn-primary"
                    value="Submit for Approval"
                    onClick={this.handleSubmit.bind(this, "Approval")}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </form>
        {internalUser === "InternalUser" ? (
          <div className="row">
            <div className="col-sm-12">
              {validateEntitlement(
                FUNCTIONALITY.generateXMLCSV,
                ENTITLEMENTS.create
              ) && this.state.kycForm.kycStatus === "APPROVED" ? (
                <React.Fragment>
                  <div className="float-right">
                    <button
                      className="btn btn-info"
                      onClick={this.generateCSXml.bind(
                        this,
                        this.props.clientType
                      )}
                    >
                      Generate XML
                    </button>
                    &nbsp;&nbsp;
                    <XmlDownload
                      type="client"
                      obj={{
                        clientId:
                          Auth.get("userType") !== "InternalUser"
                            ? Auth.get("userId")
                            : this.props.clientId,
                        userType:
                          Auth.get("userType") !== "InternalUser"
                            ? Auth.get("userType")
                            : this.props.clientType,
                      }}
                    />
                  </div>
                </React.Fragment>
              ) : null}
            </div>
            &nbsp;&nbsp;
            <div className="col-sm-12">
              <div className="jumbotron pt-2 pb-2 text-center">
                {this.role === "03" ? (
                  <input
                    type="button"
                    disabled={disableConfirmButton}
                    className="btn btn-primary  mr-2"
                    value="Confirm"
                    onClick={this.handleStatus.bind(this)}
                  />
                ) : (
                  <input
                    type="button"
                    disabled={disableApproveButton}
                    className="btn btn-link mr-2"
                    value="Approve"
                    onClick={this.handleStatus.bind(this)}
                  />
                )}
                <input
                  type="button"
                  disabled={disableRejectButton}
                  className="btn btn-link"
                  value="Reject"
                  onClick={this.handleStatus.bind(this)}
                />
                {this.state.regenerateMsg && (
                  <span className="alert alert-success">
                    {this.state.regenerateMsg}
                  </span>
                )}
                {/* {((internalUser === 'InternalUser' && this.state.kycForm.kycStatus === 'SUBMITTED') || (this.state.kycForm.kycStatus === 'CONFIRMED')) ?
                                    <button className="btn btn-info float-right" onClick={this.generateCSXml.bind(this, this.props.clientType)}>Generate XML</button>
                                    : null} */}
                {internalUser === "InternalUser" &&
                  (this.state.kycForm.rejectionReason ||
                    this.state.displayRejReason) ? (
                  <React.Fragment>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>Rejection Reason</h5>
                        <textarea
                          className="form-control text-center"
                          maxLength="500"
                          placeholder="Enter Reason for Rejection of KYC"
                          rows="2"
                          name="rejectionReason"
                          value={this.state.kycForm.rejectionReason}
                          cols="50"
                          onChange={this.onChange}
                          disabled={internalUser !== "InternalUser"}
                        ></textarea>
                      </div>
                    </div>
                  </React.Fragment>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

// HOC to inject outlet context props and navigation function
export default withOutletPropsAndNavigation(Customer);